import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { IDepartment, IAcademy, ISubject } from '../../types/departamento';

interface IDepartamentosPage {
	departments: IDepartment[];
	academies: IAcademy[];
	subjects: ISubject[];
}

const initialState: IDepartamentosPage = {
	departments: [],
	academies: [],
	subjects: [],
};

export const departamentosPageSlice = createSlice({
	name: 'departamentosPage',
	initialState,
	reducers: {
		setDepartments: (state, action: PayloadAction<IDepartment[]>) => {
			state.departments = action.payload;
		},
		addDepartment: (state, action: PayloadAction<IDepartment>) => {
			state.departments.push(action.payload);
		},
		editDepartment: (state, action: PayloadAction<IDepartment>) => {
			const idx = state.departments.findIndex((d) => d.id === action.payload.id);
			if (idx !== -1) state.departments[idx] = action.payload;
		},
		removeDepartment: (state, action: PayloadAction<number>) => {
			const deptId = action.payload;
			state.subjects = state.subjects.filter((s) => s.departmentId !== deptId);
			state.academies = state.academies.filter((a) => a.departmentId !== deptId);
			state.departments = state.departments.filter((d) => d.id !== deptId);
		},
		setAcademies: (state, action: PayloadAction<IAcademy[]>) => {
			state.academies = action.payload;
		},
		addAcademy: (state, action: PayloadAction<IAcademy>) => {
			state.academies.push(action.payload);
		},
		editAcademy: (state, action: PayloadAction<IAcademy>) => {
			const idx = state.academies.findIndex((a) => a.id === action.payload.id);
			if (idx !== -1) state.academies[idx] = action.payload;
		},
		removeAcademy: (state, action: PayloadAction<number>) => {
			const academyId = action.payload;
			state.subjects = state.subjects.filter((s) => s.academyId !== academyId);
			state.academies = state.academies.filter((a) => a.id !== academyId);
		},
		setSubjects: (state, action: PayloadAction<ISubject[]>) => {
			state.subjects = action.payload;
		},
		addSubject: (state, action: PayloadAction<ISubject>) => {
			state.subjects.push(action.payload);
		},
		editSubject: (state, action: PayloadAction<ISubject>) => {
			const idx = state.subjects.findIndex((s) => s.id === action.payload.id);
			if (idx !== -1) state.subjects[idx] = action.payload;
		},
		removeSubject: (state, action: PayloadAction<number>) => {
			state.subjects = state.subjects.filter((s) => s.id !== action.payload);
		},
	},
});

export const {
	setDepartments,
	addDepartment,
	editDepartment,
	removeDepartment,
	setAcademies,
	addAcademy,
	editAcademy,
	removeAcademy,
	setSubjects,
	addSubject,
	editSubject,
	removeSubject,
} = departamentosPageSlice.actions;

export default departamentosPageSlice.reducer;
